var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { EngineService } from 'src/app/engine/engine.service';
import { AnimationService } from 'src/app/engine/animation.service';
import { ViewService } from '../../view.service';
import { filter, takeUntil, throttleTime, auditTime } from 'rxjs/operators';
import { EventsEnum } from 'src/app/engine/models/events.enum';
import { ViewState } from '../../state/view.state';
var ViewScrubberComponent = /** @class */ (function () {
    // ---------- Lifecycle Hooks ----------
    function ViewScrubberComponent(engineService, animationService, renderer, viewService, changeDetectorRef, store) {
        this.engineService = engineService;
        this.animationService = animationService;
        this.renderer = renderer;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        this.store = store;
        // ---------- Inputs ----------
        this.showHandle = true;
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
        this.trackWidth = 0;
        this.dragPosition = { x: 16, y: 0 };
        this.dragMove = new Subject();
    }
    ViewScrubberComponent.prototype.ngOnInit = function () {
        this.initChapterListener();
        this.initTimelineListener();
        this.initDragListener();
    };
    ViewScrubberComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Listeners ----------
    ViewScrubberComponent.prototype.initChapterListener = function () {
        var _this = this;
        this.selectedChapterId$.pipe(filter(function (chapterId) { return chapterId != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapterId) {
            _this.timerange = _this.animationService.getChapterLocalTimerange(chapterId);
        });
    };
    ViewScrubberComponent.prototype.initTimelineListener = function () {
        var _this = this;
        // Listen to timeline ticks
        this.engineService.getEvent(EventsEnum.TimelinePlaying)
            .pipe(throttleTime(20), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) { return _this.tick(event.time); });
        // listen for timeline scrub
        this.engineService.getEvent(EventsEnum.TimelineScrubbed)
            .pipe(throttleTime(20), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) {
            // manually set scrubber UI
            var scrubPercent = _this.calcScrubbedPercent(event.time);
            _this.setScrubberBar(scrubPercent);
        });
    };
    ViewScrubberComponent.prototype.initDragListener = function () {
        var _this = this;
        this.dragMove.pipe(auditTime(20), takeUntil(this.ngUnsubscribe)).subscribe(function (event) {
            var percent = _this.calculateHandlePercent();
            _this.scrubToPercent(percent);
        });
    };
    // ---------- Class Methods ----------
    ViewScrubberComponent.prototype.handleDragMoved = function (event) {
        this.dragMove.next(event);
    };
    ViewScrubberComponent.prototype.tick = function (time) {
        if (!this.timerange) {
            return;
        }
        var scrubPercent = this.calcScrubbedPercent(time);
        this.setScrubberBar(scrubPercent);
        if (this.trackWidth === 0) {
            this.trackWidth = this.track.nativeElement.offsetWidth;
        }
        if (this.showHandle) {
            this.dragPosition = __assign({}, this.dragPosition, { x: 16 + this.trackWidth * (scrubPercent / 100) });
            this.changeDetectorRef.markForCheck();
        }
    };
    ViewScrubberComponent.prototype.calculateHandlePercent = function () {
        var _a = this.scrubber.nativeElement.getBoundingClientRect(), left = _a.left, right = _a.right;
        var adjustedWidth = right - left - 32; // Account for padding
        var handleLeft = this.handle.nativeElement.getBoundingClientRect().left;
        var percent = (handleLeft - left) / adjustedWidth * 100;
        return percent;
    };
    ViewScrubberComponent.prototype.scrubToPercent = function (percent) {
        var localTime = (percent / 100) * this.timerange.lastTime;
        var which = (percent === 0) ? 'second' : 'first';
        var activeChapterId = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterId);
        var globalTime = this.animationService.mapLocalTimeToGlobal(activeChapterId, localTime);
        this.animationService.scrub({ time: globalTime, which: which });
    };
    ViewScrubberComponent.prototype.handlePlayClick = function () {
        this.viewService.toggleAnimation();
    };
    ViewScrubberComponent.prototype.setScrubberBar = function (percent) {
        this.renderer.setStyle(this.bar.nativeElement, 'width', percent + "%");
    };
    ViewScrubberComponent.prototype.calcScrubbedPercent = function (time) {
        var _a = this.timerange, firstTime = _a.firstTime, lastTime = _a.lastTime;
        var localTime = this.animationService.mapGlobalTimeToLocal(time).time;
        // keep time in range
        var normalizedTime = Math.max(firstTime, Math.min(localTime, lastTime));
        var scrubPercent = Math.round((normalizedTime / lastTime) * 100);
        return scrubPercent;
    };
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], ViewScrubberComponent.prototype, "animationPlaying$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], ViewScrubberComponent.prototype, "selectedChapterId$", void 0);
    __decorate([
        Select(ViewState.getCanTouch),
        __metadata("design:type", Observable)
    ], ViewScrubberComponent.prototype, "canTouch$", void 0);
    return ViewScrubberComponent;
}());
export { ViewScrubberComponent };
